/* eslint-disable no-console */
import { register } from 'register-service-worker'

const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'La aplicación está siendo servida desde la caché por un trabajador del servicio.'
      )
    },
    registered (registration) {
      console.log('El trabajador del servicio se ha registrado.')
      setInterval(() => {
        registration.update().catch((err) => {
          console.warn('[SW] update check failed:', err && err.message)
        })
      }, UPDATE_CHECK_INTERVAL_MS)
    },
    cached () {
      console.log('El contenido se ha almacenado en caché para su uso sin conexión.')
    },
    updatefound () {
      console.log('Se está descargando contenido nuevo.')
    },
    updated (registration) {
      console.log('Hay nuevo contenido disponible; porfavor refresca.')
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline () {
      console.log('No se encontró conexión a Internet. La aplicación se está ejecutando en modo fuera de línea.')
    },
    error (error) {
      console.error('Error durante el registro del trabajador del servicio:', error)
    }
  })
}
